import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Jornal from '../../../../components/auth/leis/listar/form_jornal'


function JornalLeiScreen() {

    return (
        <Fragment>
            <Head titulo="Editando Categoria - Módulo Legislativo" />
            <HeaderLogged />
            <Container>
               <Jornal />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default JornalLeiScreen;